import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataService, environment, MyHttpClientFactory } from '@ups/xplat/core';
import { Sublocation } from '../models';

@Injectable({
  providedIn: 'root',
})
export class SublocationService extends DataService<unknown> {
  route: string;

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/Sublocation',
      httpClient,
      httpFactory
    );
  }

  getSublocationsByWarehouse(warehouseId: string): Observable<Sublocation[]> {
    return this.httpClient.get<Sublocation[]>(`${this.route}/${warehouseId}`);
  }
}
